import { render, staticRenderFns } from "./DateCalculateBehaviorEditor.vue?vue&type=template&id=9a4b7be6&scoped=true&"
import script from "./DateCalculateBehaviorEditor.vue?vue&type=script&lang=ts&"
export * from "./DateCalculateBehaviorEditor.vue?vue&type=script&lang=ts&"
import style0 from "./DateCalculateBehaviorEditor.vue?vue&type=style&index=0&id=9a4b7be6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a4b7be6",
  null
  
)

export default component.exports